import React from "react";
import { PProgressSpinnerStyle as S } from "./PProgressSpinner.style";
import { ProgressSpinner, ProgressSpinnerProps } from "primereact/progressspinner";

export const PProgressSpinner = React.forwardRef<ProgressSpinner, ProgressSpinnerProps>((props, ref) => (
  <S.PProgressSpinner {...props} ref={ref} />
));
